import { graphql } from '@/gql';
import type { AddPartnerCallerCreditsMutationVariables } from '@/gql/graphql';
import { mutationExecute } from '@/Utils/graphqlAPI';
import type { PartnerCaller } from '@/models/partnerCaller';

export const addPartnerCallerCredits = async ({
  phoneNumber,
  partnerCode,
  rideCredits,
  notes,
}: AddPartnerCallerCreditsMutationVariables): Promise<PartnerCaller> => {
  const response = await mutationExecute({
    mutation: graphql(`
      mutation AddPartnerCallerCredits($phoneNumber: String!, $partnerCode: String!, $rideCredits: Float!, $notes: String!) {
        addPartnerCallerCredits(phoneNumber: $phoneNumber, partnerCode: $partnerCode, rideCredits: $rideCredits, notes: $notes) {
          callerId
          partnerId
          credits
          rides
        }
      }
    `),
    variables: {
      phoneNumber,
      partnerCode,
      rideCredits,
      notes,
    },
  });

  return response.data?.addPartnerCallerCredits!;
};
